import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { GenericLinkComponent } from './generic-link.component';

@NgModule({
  imports: [CommonModule, MatIconModule, RouterModule, GenericLinkComponent],
  exports: [GenericLinkComponent],
})
export class GenericLinkModule {}
